import Vue from 'vue';
import VueRouter from 'vue-router';
import store from '@/store';
import Home from '@/views/Home.vue';
import Signin from '@/views/Signin.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
  },
  {
    path: '/board/:id',
    name: 'Board',
    component: () =>
      import(/* webpackChunkName: "board" */ '../views/Board.vue'),
    props: true,
    meta: {
      adminOnly: true,
    },
  },
  {
    path: '/constructions',
    name: 'Constructions',
    component: () =>
      import(/* webpackChunkName: "constructions" */ '../views/Constructions.vue'),
    meta: {
      adminOnly: true,
    },
  },
  {
    path: '/places',
    name: 'Places',
    component: () =>
      import(/* webpackChunkName: "places" */ '../views/Places.vue'),
    meta: {
      adminOnly: true,
    },
  },
  {
    path: '/owner/:id',
    name: 'Owner',
    component: () =>
      import(/* webpackChunkName: "owner" */ '../views/Owner.vue'),
    props: true,
    meta: {
      adminOnly: true,
    },
  },
  {
    path: '/owners',
    name: 'Owners',
    component: () =>
      import(/* webpackChunkName: "owners" */ '../views/Owners.vue'),
    meta: {
      adminOnly: true,
    },
  },
  {
    path: '/signin',
    name: 'Signin',
    component: Signin,
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  if (
    to.matched.some((record) => record.meta.requiresAuth || record.meta.adminOnly) &&
    !store.getters.isAuthenticated
  ) {
    next({ name: 'Signin', replace: true });
  } else if (
    to.matched.some((record) => record.meta.adminOnly) &&
    !store.getters.isAdmin
  ) {
    next({ name: 'Home', replace: true });
  } else {
    next();
  }
});

export default router;
